<template>
  <div>
    <v-dialog v-model="showchange" width="800">
      <template #activator="{ on }">
        <v-btn
          v-if="!$store.state.isFacebook"
          flat
          outline
          class="primary mr-2"
          :style="`line-height: 10px;color: ${$vuetify.theme.primary};`"
          v-on="on"
          >{{ $t('Change Password') }}</v-btn
        >
      </template>
      <v-card v-if="showchange">
        <v-container>
          <v-card-text>
            <h1>{{ $t('Change Password') }}</h1>
            <form class="form-control" :class="{ 'has-error': errors.has('password') }">
              <label>{{ $t('New password') }}</label>
              <input
                ref="password"
                v-model.trim="password"
                v-validate="'required|isValidPassword'"
                name="password"
                type="password"
                :data-vv-as="$t('password')"
                autocomplete="on"
              />
              <span v-if="errors.has('password')" class="text-error">{{
                errors.first('password')
              }}</span>
            </form>
            <PasswordValidation
              v-show="!isValidPassword"
              :value="password"
              :is-valid.sync="isValidPassword"
              class="mt-3"
            />
            <form
              class="form-control"
              :class="{ 'has-error': errors.has('passwordconfirm'), 'mt-3': true }"
            >
              <label>{{ $t('Confirm password') }}</label>
              <input
                v-model.trim="confirmpassword"
                v-validate="'required|confirmed:password'"
                name="passwordconfirm"
                :data-vv-as="$t('password')"
                type="password"
                autocomplete="on"
              />
              <span v-if="errors.has('passwordconfirm')" class="text-error">{{
                errors.first('passwordconfirm')
              }}</span>
            </form>
            <div class="text-xs-center">
              <v-btn outline color="grey" @click="cancel">{{ $t('cancel') }}</v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                depressed
                color="primary"
                @click="onchangepassword"
                >{{ $t('Save') }}</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import PasswordValidation from '@/components/elements/PasswordValidation'

export default {
  components: {
    PasswordValidation
  },
  props: ['userid', 'type'],
  data() {
    return {
      showchange: false,
      loading: false,
      password: '',
      confirmpassword: '',
      isValidPassword: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isFacebook', 'currentLang'])
  },
  methods: {
    cancel() {
      //   this.password = ''
      //   this.confirmpassword = ''
      this.showchange = false
    },
    async onchangepassword() {
      var vm = this

      var result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        return false
      }

      this.loading = true

      try {
        var response = await this.changepassword()
        if (response.responsecode === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
          if (this.$store.state.userid == this.userid) {
            this.$store.dispatch('logout', null).then()
            if (this.type == 'admin') {
              this.$router.push('/' + this.currentLang + '/nigol')
            } else {
              this.$router.push('/' + this.currentLang + '/login')
            }
          }
          this.showchange = false
        }
      } catch (error) {
        //
      } finally {
        this.loading = false
      }
    },
    changepassword() {
      var data = {
        userid: this.userid,
        pageid: this.selectedBot.pageid,
        password: this.confirmpassword
      }
      return new Promise((resolve, reject) => {
        api.changeticketpasswordadminuser({ data: data }, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/ChangePassword.vue